import { FC } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import BlogList from "../components/Blog/BlogList";

interface BlogProps {
  locale: string;
  setLocale: (locale: string) => void;
}

const Blog: FC<BlogProps> = ({ locale, setLocale }) => {
  return (
    <>
      <Header activeNav="blog" setLocale={setLocale} />
      <BlogList locale={locale} />
      <Footer />
    </>
  );
};

export { Blog };
